/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccsl_Export_Document_TitleInputs */



/**
* | output |
* | --- |
* | "Document Title" |
*
* @param {Ccsl_Export_Document_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_document_title = /** @type {((inputs?: Ccsl_Export_Document_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Document_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Titre du document")
	if (locale === "de") return /** @type {LocalizedString} */ ("Dokumenttitel")
	if (locale === "it") return /** @type {LocalizedString} */ ("Titolo del documento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Название документа")
	if (locale === "es") return /** @type {LocalizedString} */ ("Título del documento")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("文件标题")
	if (locale === "ja") return /** @type {LocalizedString} */ ("文書タイトル")
	if (locale === "hi") return /** @type {LocalizedString} */ ("दस्तावेज़ का शीर्षक")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Título do documento")
	return /** @type {LocalizedString} */ ("Document Title")
});